/**
 * スコア一覧API（権限に応じたフィルタ）
 * 管理者: 全件 / 教育者: 担当学生のみ / 学生: 自身のみ
 */

async function fetchWithAuth(url: string, options: RequestInit = {}) {
  const response = await fetch(url, {
    ...options,
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ message: 'エラーが発生しました' }));
    throw new Error(error.message || `HTTP error! status: ${response.status}`);
  }

  return response.json();
}

export interface ScoreRow {
  interview_id: number;
  user_id: number;
  user_name?: string;
  user_email?: string;
  interview_summary?: string;
  patient_score_value?: number;
  dentist_score_value?: number;
  overall_score_value?: number | null;
  overall_score_total?: number | null;
  overall_score_max?: number | null;
  conditionInstructionId?: number | null;
  created: string;
}

export interface ScoresResponse {
  scores: ScoreRow[];
  statistics: { avg: number; min: number; max: number };
  pagination: { page: number; limit: number; total: number };
}

export async function getScores(params?: {
  user_id?: number;
  interview_id?: number;
  score_type?: string;
  page?: number;
  limit?: number;
}): Promise<ScoresResponse> {
  const queryParams = new URLSearchParams();
  if (params?.user_id) queryParams.append('user_id', params.user_id.toString());
  if (params?.interview_id) queryParams.append('interview_id', params.interview_id.toString());
  if (params?.score_type) queryParams.append('score_type', params.score_type);
  if (params?.page) queryParams.append('page', params.page.toString());
  if (params?.limit) queryParams.append('limit', params.limit.toString());
  const query = queryParams.toString();
  return fetchWithAuth(`/api/scores${query ? `?${query}` : ''}`);
}

export async function getAllScores(): Promise<ScoresResponse> {
  return fetchWithAuth('/api/scores?all=true&summary=true');
}
